import https from "./http";

const getVertederoId = async (idVertedero) => {
  const response = await https.post("contadores", {
    vert_id: idVertedero,
  });

  if (response?.data?.data) {
    return response?.data?.data;
  }
};

const getRef = async (idVertedero) => {
  let result = "";
  try {
    const data = await getVertederoId(idVertedero);
    if (("" + idVertedero).length < 4) {
      for (let i = 0; i < 4 - ("" + idVertedero).length; i++) {
        result += "0";
      }
    }
    result += idVertedero;
    result += "-";
    if (("" + data).length < 6) {
      for (let i = 0; i < 6 - ("" + data).length; i++) {
        result += "0";
      }
    }
    result += data;
  } catch (_error) {}
  return result;
};

export const crearAlbaran = async (payload) => {
  try {
    const tieneDestinoCatalogo =
      payload?.destino != null &&
      payload?.destino !== "" &&
      payload?.destino !== "-" &&
      payload?.destino !== "otro";
    const ref = tieneDestinoCatalogo ? await getRef(payload.destino) : null;
    const response = await https.post("addAlbaran", {
      ...payload,
      destino: tieneDestinoCatalogo ? payload.destino : null,
      destino_otro: tieneDestinoCatalogo
        ? null
        : payload?.destino_otro || null,
      ...(ref ? { ref } : {}),
    });
    console.log(response);
    return response;
  } catch (_error) {
    throw _error;
  }
};

export const crearDiContenedor = async (payload) => {
  try {
    const ref = payload?.ref || (await getRef(payload?.destino));
    return await https.post("contenedores/di", {
      ...payload,
      ref: ref,
    });
  } catch (_error) {
    throw _error;
  }
};

export const completarDiContenedor = async (id, payload) => {
  try {
    return await https.post(`contenedores/di/${id}`, payload);
  } catch (_error) {
    throw _error;
  }
};

export const firmarDiContenedor = async (
  id,
  {
    conductor_id,
    firma,
    firmante_nombre,
    firmante_dni,
    cliente_email_override,
  },
) => {
  return await https.post(`contenedores/di/${id}/firmar`, {
    conductor_id,
    firma,
    firmante_nombre,
    firmante_dni,
    cliente_email_override: cliente_email_override || null,
  });
};

// El DI pendiente (offline) puede ser de obra o de contenedor.
export const enviarAlbaranPendiente = (payload) =>
  payload?.tipo === "contenedor"
    ? crearDiContenedor(payload)
    : crearAlbaran(payload);

export const getAlbaran = async (id) => {
  try {
    const response = await https.get(`albaranes/${id}`);
    return response;
  } catch (_error) {
    throw _error;
  }
};

export const savePreferences = async (payload) => {
  try {
    const response = await https.post("preferences/save", {
      ...payload,
    });
    console.log(response);
    return response;
  } catch (_error) {
    throw _error;
  }
};
